import axios from 'axios';
import {
  GET_OWNERS, GET_OWNERS_SUCCESS, GET_OWNERS_ERROR,
  GET_OWNER, GET_OWNER_SUCCESS, GET_OWNER_ERROR,
  ADD_OWNER, ADD_OWNER_SUCCESS, ADD_OWNER_ERROR,
  EDIT_OWNER, EDIT_OWNER_SUCCESS, EDIT_OWNER_ERROR,
  DELETE_OWNER, DELETE_OWNER_SUCCESS, DELETE_OWNER_ERROR,
  UPDATE_OWNER_PIN, UPDATE_OWNER_PIN_SUCCESS, UPDATE_OWNER_PIN_ERROR,
  CLEAR_OWNER_STATE,
} from './types';

const apiBaseURL = process.env.VUE_APP_API_URL;
const requestIds = {};
const authorization = () => {
  const headers = axios.defaults && axios.defaults.headers && axios.defaults.headers.common || {};
  return headers.Authorization || headers.authorization || null;
};
const safeError = (error) => ({
  response: error.response ? { status: error.response.status, data: error.response.data } : null,
});

const request = async ({ commit }, pending, success, failure, send) => {
  const token = authorization();
  const requestId = (requestIds[pending] || 0) + 1;
  requestIds[pending] = requestId;
  const isCurrent = () => authorization() === token && requestIds[pending] === requestId;
  commit(pending);
  try {
    const { data } = await send();
    if (!isCurrent()) return null;
    commit(success, data);
    return data;
  } catch (error) {
    if (isCurrent()) commit(failure, safeError(error));
    throw error;
  }
};

export default {
  [GET_OWNERS]: (context) => request(context, GET_OWNERS, GET_OWNERS_SUCCESS, GET_OWNERS_ERROR,
    () => axios.get(`${apiBaseURL}/operators`, { timeout: 30000 })),
  [GET_OWNER]: (context, id) => request(context, GET_OWNER, GET_OWNER_SUCCESS, GET_OWNER_ERROR,
    () => axios.get(`${apiBaseURL}/operators/${id}`, { timeout: 30000 })),
  [ADD_OWNER]: (context, owner) => request(context, ADD_OWNER, ADD_OWNER_SUCCESS, ADD_OWNER_ERROR,
    () => axios.post(`${apiBaseURL}/operators`, owner, { timeout: 30000 })),
  [EDIT_OWNER]: (context, owner) => request(context, EDIT_OWNER, EDIT_OWNER_SUCCESS, EDIT_OWNER_ERROR,
    () => axios.post(`${apiBaseURL}/operators/${owner.id}`, { ...owner, _method: 'PUT' }, { timeout: 30000 })),
  [DELETE_OWNER]: (context, id) => request(context, DELETE_OWNER, DELETE_OWNER_SUCCESS, DELETE_OWNER_ERROR,
    () => axios.post(`${apiBaseURL}/operators/${id}`, { _method: 'DELETE' }, { timeout: 30000 })),
  [UPDATE_OWNER_PIN]: (context, { id, pin }) => request(context, UPDATE_OWNER_PIN, UPDATE_OWNER_PIN_SUCCESS, UPDATE_OWNER_PIN_ERROR,
    () => axios.post(`${apiBaseURL}/operators/${id}/pin`, { _method: 'PUT', pin }, { timeout: 15000 })),
  [CLEAR_OWNER_STATE]: ({ commit }) => { commit(CLEAR_OWNER_STATE); },
};
